/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuptypenumber2Inputs */

const en_signuptypenumber2 = /** @type {(inputs: Signuptypenumber2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

const de_signuptypenumber2 = /** @type {(inputs: Signuptypenumber2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahl`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {Signuptypenumber2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuptypenumber2 = /** @type {((inputs?: Signuptypenumber2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuptypenumber2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuptypenumber2(inputs)
	return de_signuptypenumber2(inputs)
});
export { signuptypenumber2 as "signupTypeNumber" }